import * as React from 'react';
import { ReactNode } from "react";

export interface ITabPanelProps {
    value: number,
    index: number,
    children: ReactNode,
    className?: string
}

export const TabPanel = (props: ITabPanelProps) => {
    return (
        <div className="tab-panel" hidden={props.value !== props.index}>
            {props.value === props.index && (
                <div className={`tab-panel-child ${props.className}`}>{props.children}</div>
            )}
        </div>
    );
};